import React, { useState, useEffect } from "react";
import { PageHeader } from "components/ui";
import {
  Grid,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import GriStandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import GriFormComponent from "components/customizedStandardsComponent/GriFormComponent";
import UploadEvidenceComponent from "components/customizedStandardsComponent/UploadEvidenceComponent";
import DownloadReport from "components/customizedStandardsComponent/DownloadReport";
import DownloadPostReviewGapForm from "components/customizedStandardsComponent/DownloadPostReviewGapForm";
import UploadPostReviewGapForm from "components/customizedStandardsComponent/UploadPostReviewGapForm";
import DownloadPostReviewReports from "components/customizedStandardsComponent/DownloadPostReviewReports";
import { getAnnexure9 } from "data/standards/griStandards";
import StandardsSelector from "components/customizedStandardsComponent/GriStandardsSelector";
import NavigationButtons from "helper/navigation/NavigationButtons";
import ReusableFormComponent from "components/customizedStandardsComponent/EsgFormComponent";
import { CANADA_SPECIFIC_COMPLIANCE_FORM } from "data/forms/griFormSchema";
import {
  convertedEnvironmentalActsData,
  annexure7,
  esgGuidelines,
} from "data/reports/relevantReports";
import ReportsReviewDialog from "components/customizedStandardsComponent/ReportsReviewDialog";
import UploadEvidenceReviewReports from "components/customizedStandardsComponent/UploadEvidenceReviewReports";
import DynamicDropdownForm, {
  ReusableInputDropdown,
} from "components/customizedStandardsComponent/ReusableSelect";
import {
  ENVIRONMENTAL_ACTS,
  CANADIAN_ENVIRONMENTAL_LEGISLATION,
} from "data/dropdowns/countryDropdown";
import PivotSelectForm from "components/customizedStandardsComponent/PivotSelectForm";
import DropdownWithChecker from "components/customizedStandardsComponent/DropdownWithChecker";
import CountryReportsComponent from "components/customizedStandardsComponent/CountryReportsComponent";
import {
  environmentalData,
  federalData,
  federalRegulations,
} from "data/regulations/canadaRegulations";
import CanadaReports from "components/customizedStandardsComponent/CanadaReports";
const Canada = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);
  const [reportData, setReportData] = useState({
    selectedStandards: [],
    companyInfo: {},
  });
  const [showReviewPopup, setShowReviewPopup] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const steps = [
    "Select Environmental Acts",
    "Canadian Environmental Legislation",
    "ESG Guidelines for Canada",
    "Fill Canada-Specific Compliance Form",
    "Upload Evidence",
    "Select ESG Compliance Standards",
    "Upload Evidence and Review Reports",
    "Download Gap Form",
    "Upload Filled Gap Form",
    "Download Review Reports",
  ];

  const [stepStates, setStepStates] = useState({
    "federal-step": {
      selectedItems: { legislation: [], regulation: [] },
      activeProvince: null,
      activeTab: null,
    },
    "law-regulation-step": {
      selectedItems: { legislation: [], regulation: [] },
      activeProvince: null,
      activeTab: null,
    },
    "federal-laws-step": {
      selectedItems: { legislation: [], regulation: [] },
      activeProvince: null,
      activeTab: null,
    },
  });

  const handleSelectedItemsChange = (stepId, newSelectedItems) => {
    setStepStates((prev) => ({
      ...prev,
      [stepId]: {
        ...prev[stepId],
        selectedItems: newSelectedItems,
      },
    }));
  };

  const handleActiveProvinceChange = (stepId, activeProvince) => {
    setStepStates((prev) => ({
      ...prev,
      [stepId]: {
        ...prev[stepId],
        activeProvince,
      },
    }));
  };

  const handleActiveTabChange = (stepId, activeTab) => {
    setStepStates((prev) => ({
      ...prev,
      [stepId]: {
        ...prev[stepId],
        activeTab,
      },
    }));
  };

  useEffect(() => {
    if (activeStep === 6 && prevStep === 5) {
      setShowReviewPopup(true);
    }
  }, [activeStep, prevStep]);

  const handleNext = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSaveStandards = (selectedStandards) => {
    setReportData((prev) => ({
      ...prev,
      selectedStandards,
    }));
    console.log("Standards saved:", selectedStandards);
  };

  const handleClosePopup = () => {
    setShowReviewPopup(false);
  };

  const handleSkipToStep5 = () => {
    setPrevStep(activeStep);
    setActiveStep(7);
    setShowReviewPopup(false);
  };

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <CountryReportsComponent
            stepId="federal-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={environmentalData}
            title="Federal Environmental Laws and Regulations"
            legislationButtonTitle="Federal Environmental Laws"
            regulationButtonTitle="Federal Environmental Regulations"
            externalSelectedItems={stepStates["federal-step"].selectedItems}
            onSelectedItemsChange={handleSelectedItemsChange}
            externalActiveProvince={stepStates["federal-step"].activeProvince}
            onActiveProvinceChange={handleActiveProvinceChange}
            externalActiveTab={stepStates["federal-step"].activeTab}
            onActiveTabChange={handleActiveTabChange}
          />
        );
      case 1:
        return (
          <CountryReportsComponent
            stepId="law-regulation-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={federalRegulations}
            title="Laws and Regulations"
            externalSelectedItems={
              stepStates["law-regulation-step"].selectedItems
            }
            onSelectedItemsChange={handleSelectedItemsChange}
            externalActiveProvince={
              stepStates["law-regulation-step"].activeProvince
            }
            onActiveProvinceChange={handleActiveProvinceChange}
            externalActiveTab={stepStates["law-regulation-step"].activeTab}
            onActiveTabChange={handleActiveTabChange}
          />
        );

      case 2:
        return (
          <CountryReportsComponent
            stepId="federal-laws-step"
            onPrevious={handleBack}
            onNext={handleNext}
            initialItems={federalData}
            title="Federal Environmental Laws and Regulations"
            legislationButtonTitle="Federal ESHS Standard / Requirements"
            regulationButtonTitle="Provincial / Territorial  ESHS Standards / Requirements"
            externalSelectedItems={
              stepStates["federal-laws-step"].selectedItems
            }
            onSelectedItemsChange={handleSelectedItemsChange}
            externalActiveProvince={
              stepStates["federal-laws-step"].activeProvince
            }
            onActiveProvinceChange={handleActiveProvinceChange}
            externalActiveTab={stepStates["federal-laws-step"].activeTab}
            onActiveTabChange={handleActiveTabChange}
          />
        );

      case 3:
        return (
          <ReusableFormComponent
            key="form-step-2"
            {...CANADA_SPECIFIC_COMPLIANCE_FORM}
            onNext={handleNext}
            onPrevious={handleBack}
            showPreviousButton={true}
          />
        );
      case 4:
        return (
          <UploadEvidenceComponent
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 5:
        return (
          <StandardsSelector
            standards={getAnnexure9("Canada")}
            onNext={handleNext}
            onSave={handleSaveStandards}
            title="Select and download country Specific Reports / Assessments / Analysis"
            nextButtonText="Next"
            initialSelectedStandards={reportData.selectedStandards.map(
              (s) => s.id
            )}
            showReportCountdownButton={true}
            ReportDownloadButtonShow={true}
          />
        );
      case 6:
        return (
          <UploadEvidenceReviewReports
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );
      case 7:
        return (
          <DownloadPostReviewGapForm
            key="gap-download-step-6"
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );

      case 8:
        return (
          <UploadPostReviewGapForm
            key="gap-upload-step-7"
            onPrevious={handleBack}
            onNext={handleNext}
          />
        );

      case 9:
        return (
          <DownloadPostReviewReports
            key="post-review-download-step-8"
            standardName="Country Specific"
            onPrevious={handleBack}
            showReportCountdownButton={true}
            
          />
        );

      default:
        return "Unknown step";
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
          </Box>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <NavigationButtons
                imageKey="dashboardImg4_2"
                title={"Country Specific ESG Compliance"}
                activeStep={activeStep}
                onBack={handleBack}
              />
            </Box>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          {getStepContent(activeStep)}
        </Grid>

        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              mb: 2,
            }}
          ></Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: -1,
            }}
          >
            {steps.map((_, index) => (
              <Box
                key={index}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: index <= activeStep ? "#02462E" : "#e0e0e0",
                  mx: 1,
                }}
              />
            ))}
          </Box>
        </Grid>
      </Grid>

      <ReportsReviewDialog
        open={showReviewPopup}
        onClose={handleClosePopup}
        onSkip={handleSkipToStep5}
      />
    </>
  );
};

export default Canada;
